<div class="cv-revised-fields-container" #contentRevised>
	<div class="cv-revised-fields-container__failed">
		<div class="cv-revised-fields-container__title">
			<span
				><i class="fas fa-ban"></i>
				Failed fields
			</span>
		</div>
		<div class="cv-revised-fields-container__info">
			<span>
				Marked these fields as “failed” when you last reviewed this document. Here are the revised
				values.</span
			>
		</div>
		<table class="cv-revised-fields-container__table" *ngIf="failed">
			<colgroup>
				<col span="1" style="width: 50%;">
				<col span="1" style="width: 25%;">
				<col span="1" style="width: 25%;">
			 </colgroup>
			<thead class="cv-revised-fields-container__table-head">
				<tr>
					<td>Current value</td>
					<td>Previous value</td>
					<td>Actions</td>
				</tr>
			</thead>
			<tbody>
				<tr
					[ngClass]="{
						'cv-revised-fields-container__table-body': true,
						'cv-revised-fields-container__revisedHide': !item.metadata.length
					}"
					#revisedFailed
					[attr.path]="item.path"
					*ngFor="let item of failed; let i = index"
				>
					<td class="cv-revised-fields-container__table-body__val">
						<div class="cv-revised-fields-container__info-values">
							<label class="cv-revised-fields-container__info-field">{{
								item.metadata.length ? item.metadata[0].DisplayText : ''
							}}</label>
							<label class="cv-revised-fields-container__info-val">{{ item.value }}</label>
						</div>
					</td>
					<td class="cv-revised-fields-container__table-body__val">
						<div class="cv-revised-fields-container__info-values">
							<label class="cv-revised-fields-container__info-field">{{
								item.historical.length && item.metadata.length ? item.metadata[0].DisplayText : ''
							}}</label>
							<label class="cv-revised-fields-container__info-val">
								{{item.historical.length
									? item.historical[item.historical.length - 1].val ||
									  item.historical[item.historical.length - 1].Val
									: ''}}
							</label>
							<label *ngIf="!item.historical.length">
								<i><small>Not Changed</small></i>
							</label>
						</div>
					</td>
					<td class="cv-revised-fields-container__table-body__actions">
						<div class="cv-revised-fields-container__info-btn">
							<button
								class="btn btn-sm cv-btn-primary"
								*ngIf="item.historical.length > 1"
								#changesEl
								(click)="historicalVal(item.historical, changesEl)"
							>
								<i class="fas fa-clipboard-list"></i>
								<span> ({{ item.historical.length - 1 }})</span>
							</button>
							<button
								class="btn btn-sm cv-btn-light"
								*ngIf="item.metadata.length"
								[disabled]="!canRedirect(item.metadata[0].UISection || 'none')"
								(click)="goToPage(item.metadata[0].UISection || 'none')"
							>
								Go to page <i class="fas fa-arrow-right"></i>
							</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="cv-revised-fields-container__no-info" *ngIf="!failed">
			<span> No fields to show.</span>
		</div>
	</div>
	<div class="cv-revised-fields-container__changes">
		<div class="cv-revised-fields-container__title">
			<span
				><i class="fas fa-pen"></i>
				Other changes
			</span>
		</div>
		<div class="cv-revised-fields-container__info">
			<span> These fields also changed, and you might want to review them:</span>
		</div>
		<table class="cv-revised-fields-container__table" *ngIf="changes">
			<colgroup>
				<col span="1" style="width: 50%;">
				<col span="1" style="width: 25%;">
				<col span="1" style="width: 25%;">
			 </colgroup>
			<thead class="cv-revised-fields-container__table-head">
				<tr>
					<td>Current value</td>
					<td>Previous value</td>
					<td>Actions</td>
				</tr>
			</thead>
			<tbody>
				<tr
					[ngClass]="{
						'cv-revised-fields-container__table-body': true,
						'cv-revised-fields-container__revisedHide': !item.metadata.length
					}"
					*ngFor="let item of changes; let i = index"
				>
					<td class="cv-revised-fields-container__table-body__val">
						<div class="cv-revised-fields-container__info-values">
							<label class="cv-revised-fields-container__info-field">{{
								item.metadata.length ? item.metadata[0].DisplayText : ''
							}}</label>
							<label class="cv-revised-fields-container__info-val">{{ item.value }}</label>
						</div>
					</td>
					<td class="cv-revised-fields-container__table-body__val">
						<div class="cv-revised-fields-container__info-values">
							<label class="cv-revised-fields-container__info-field">{{
								item.historical.length && item.metadata.length ? item.metadata[0].DisplayText : ''
							}}</label>
							<label class="cv-revised-fields-container__info-val">{{
								item.historical.length
									? item.historical[item.historical.length - 1].val ||
									  item.historical[item.historical.length - 1].Val
									: ''
							}}</label>
						</div>
					</td>
					<td class="cv-revised-fields-container__table-body__actions">
						<div class="cv-revised-fields-container__info-btn">
							<button
								class="btn btn-sm cv-btn-primary"
								*ngIf="item.historical.length > 1"
								#changesEl
								(click)="historicalVal(item.historical, changesEl)"
							>
								<i class="fas fa-clipboard-list"></i>
								<span> ({{ item.historical.length - 1 }})</span>
							</button>
							<button
								class="btn btn-sm cv-btn-light"
								*ngIf="item.metadata.length"
								[disabled]="!canRedirect(item.metadata[0].UISection || 'none')"
								(click)="goToPage(item.metadata[0].UISection || 'none')"
							>
								Go to page <i class="fas fa-arrow-right"></i>
							</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<cv-historical-values></cv-historical-values>
		<div class="cv-revised-fields-container__no-info" *ngIf="!changes">
			<span> No fields to show.</span>
		</div>
	</div>
</div>
